exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-input-row .col-xs {\n  text-align: right; }\n\n*::-webkit-input-placeholder {\n  color: #737373;\n  opacity: 1 !important; }\n\n*:-moz-placeholder {\n  /* FF 4-18 */\n  color: #737373;\n  opacity: 1 !important; }\n\n*::-moz-placeholder {\n  /* FF 19+ */\n  color: #737373;\n  opacity: 1 !important; }\n\n*:-ms-input-placeholder {\n  /* IE 10+ */\n  color: #737373;\n  opacity: 1 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/eod-recon/components/sales-eod-container/form-sales-eod/form-sales-category/form-sales-row/form-sales-row.component.scss
// module id = ../../../../../src/app/views/daily-recon/eod-recon/components/sales-eod-container/form-sales-eod/form-sales-category/form-sales-row/form-sales-row.component.scss
// module chunks = main